module.exports = __webpack_public_path__ + "img/crossover_stopped.6cedd977.svg";